import React, { useState } from 'react';
import {
  Card,
  CardHeader,
  CardContent,
  Typography,
  List,
  ListItem,
  ListItemText,
  Button,
  Divider,
  Box,
  IconButton,
  Tooltip,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { doc, deleteDoc } from 'firebase/firestore';
import { db } from '../firebase';
import MemberRegisterFillInDialog from './MemberRegisterFillInDialog';

export default function MemberFillInsCard({ fillIns = [], onFillInRegistered }) {
  const [openRegisterDialog, setOpenRegisterDialog] = useState(false);

  const handleOpenDialog = () => setOpenRegisterDialog(true);
  const handleCloseDialog = () => setOpenRegisterDialog(false);

  // Remove a fill‑in registration
  const handleRemoveRegistration = async (fillIn) => {
    // We assume each fillIn object has a "pennantId" and a "docId" for the registration document.
    try {
      await deleteDoc(doc(db, 'Pennants', fillIn.pennantId, 'availableFillIns', fillIn.docId));
      // Refresh the registrations after deletion.
      if (onFillInRegistered) onFillInRegistered();
    } catch (error) {
      console.error('Error removing fill‑in registration:', error);
      alert('Failed to remove fill‑in registration. Please try again.');
    }
  };

  return (
    <Card sx={{ margin: 2, padding: 2 }}>
      <CardHeader title="Fill‑In Pennants" sx={{ pb: 0 }} />
      <CardContent>
        {/* Button to open the registration dialog */}
        <Box sx={{ mb: 2, textAlign: 'center' }}>
          <Button
            variant="contained"
            onClick={handleOpenDialog}
            sx={{
              textTransform: 'none',
              fontSize: { xs: '0.75rem', sm: '0.875rem' },
              padding: { xs: '4px 8px', sm: '6px 12px' },
            }}
          >
            Register as Fill‑In
          </Button>
        </Box>
        {fillIns.length === 0 ? (
          <Typography
            variant="body1"
            color="textSecondary"
            sx={{ textAlign: 'center', marginY: 2 }}
          >
            No fill‑in registrations yet.
          </Typography>
        ) : (
          <List>
            {fillIns.map((fillIn, idx) => {
              // Build a display name using the pennant's sport and name.
              const displayName = `${fillIn.sport ? `${fillIn.sport} ` : ''}${
                fillIn.pennantName || ''
              }`.trim();

              return (
                <React.Fragment key={fillIn.docId || fillIn.pennantId}>
                  <ListItem sx={{ paddingY: 2, alignItems: 'flex-start' }}>
                    <ListItemText
                      primary={
                        <Typography variant="h6" color="primary">
                          {displayName}
                        </Typography>
                      }
                      secondary={
                        <Typography variant="body2" color="textSecondary">
                          Section: {fillIn.requestedSection || 'Not specified'}
                        </Typography>
                      }
                    />
                    <Tooltip title="Remove this fill‑in registration">
                      <IconButton onClick={() => handleRemoveRegistration(fillIn)}>
                        <CloseIcon />
                      </IconButton>
                    </Tooltip>
                  </ListItem>
                  {idx < fillIns.length - 1 && <Divider />}
                </React.Fragment>
              );
            })}
          </List>
        )}
      </CardContent>

      {/* Fill‑In Registration Dialog */}
      {openRegisterDialog && (
        <MemberRegisterFillInDialog
          open={openRegisterDialog}
          onClose={handleCloseDialog}
          onFillInRegistered={onFillInRegistered}
        />
      )}
    </Card>
  );
}
